import { render, staticRenderFns } from "./hotelCard.vue?vue&type=template&id=10e4160f&scoped=true&"
import script from "./hotelCard.vue?vue&type=script&lang=js&"
export * from "./hotelCard.vue?vue&type=script&lang=js&"
import style0 from "./hotelCard.vue?vue&type=style&index=0&id=10e4160f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e4160f",
  null
  
)

export default component.exports